export const refreshTokenQuery = () => ({
  url: '/auth/refresh_token',
  method: 'POST',
});
